import React, { useCallback, useEffect, useRef, useState } from "react";
import { developAxios } from "../axios.config";
import {
	Container,
	Table,
	TableBody,
	TableCell,
	TableContainer,
	TableHead,
	TableRow,
	Paper,
} from "@mui/material";
import Select from "react-select";
import { useQuery } from "react-query";
import { TableComponents, TableVirtuoso } from "react-virtuoso";
import { grey } from "@mui/material/colors";
import { useHistory } from "react-router-dom";

interface CourseSelect {
	value: string;
	label: string;
}

type CourseItem = {
	_id: string;
	name: string;
};

type ExamItem = {
	_id: string;
	courseId: string;
	type: string;
	examName: string;
};

const VirtuosoTableComponents: TableComponents<ExamItem> = {
	Scroller: React.forwardRef<HTMLDivElement>((props, ref) => (
		<TableContainer component={Paper} {...props} ref={ref} />
	)),
	Table: (props: any) => (
		<Table
			{...props}
			sx={{ borderCollapse: "separate", tableLayout: "fixed" }}
		/>
	),
	TableHead,
	TableRow: ({ item: _item, ...props }: any) => (
		<TableRow
			{...props}
			onClick={() => {
				window.open(`/quizexambatches/${_item._id}`, "_blank");
			}}
			sx={{
				"&:hover": {
					backgroundColor: grey[300],
					cursor: "pointer",
				},
			}}
		/>
	),
	TableBody: React.forwardRef<HTMLTableSectionElement>((props, ref) => (
		<TableBody {...props} ref={ref} />
	)),
};

type ColumnData = {
	width: number;
	label: string;
	dataKey?: keyof ExamItem;
	numeric?: boolean;
};

const Quizexambybatches = () => {
	const history = useHistory();
	const [courses, setCourses] = useState<CourseItem[]>([]);
	const [selectedCourse, setSelectedCourse] = useState<CourseSelect | null>(
		null
	);
	const linkRef = useRef<HTMLInputElement>(null);
	const columns = useRef<ColumnData[]>([
		{
			width: 100,
			label: "No",
		},
		{
			width: 120,
			label: "Exam Type",
			dataKey: "type",
		},
		{
			width: 120,
			label: "Exam Name",
			dataKey: "examName",
		},
	]);
	const { data: exams, isLoading } = useQuery(
		["exams", selectedCourse?.value],
		() =>
			developAxios(localStorage.getItem("token") || "").get<{
				data: ExamItem[];
			}>(`/getquizexamsbycourse/${selectedCourse?.value}`),
		{
			enabled: !!selectedCourse,
		}
	);
	const rowContent = useCallback(
		(_index: number, row: ExamItem) => {
			return (
				<React.Fragment>
					{columns.current.map((column) => (
						<TableCell
							key={column.dataKey}
							align={column.numeric || false ? "right" : "left"}
						>
							{column.dataKey ? row[column.dataKey] : _index + 1}
						</TableCell>
					))}
				</React.Fragment>
			);
		},
		[columns]
	);

	const fixedHeaderContent = useCallback(() => {
		return (
			<TableRow className="bg-black text-white">
				{columns.current.map((column) => (
					<TableCell
						key={column.dataKey}
						variant="head"
						align={column.numeric || false ? "right" : "left"}
						style={{ width: column.width, fontWeight: 700 }}
						sx={{
							backgroundColor: "background.paper",
						}}
					>
						{column.label}
					</TableCell>
				))}
			</TableRow>
		);
	}, [columns]);

	useEffect(() => {
		developAxios(localStorage.getItem("token") || "")
			.get<{
				courses: CourseItem[];
			}>("/getallCourse")
			.then(({ data }) => {
				setCourses(data.courses);
			});
	}, []);

	const handleCourseChange = (selectedOption: CourseSelect | null) => {
		setSelectedCourse(selectedOption);
	};

	function handleResultRedirect() {
		let exam_link = linkRef.current?.value;
		if (!exam_link) return;

		const instruction_regex = /[&?]id=([a-zA-Z0-9]{24})\/?$/;
		const main_regex = /quizPortal\/([a-zA-Z0-9]{24})\/?$/;
		const id_regex = /[a-zA-Z0-9]{24}/i;

		let instruction_match = instruction_regex.exec(exam_link);
		let main_match = main_regex.exec(exam_link);
		if (instruction_match) {
			console.log({ instruction_match });
			history.push("/quizexambatches/" + instruction_match[1]);
		} else if (main_match) {
			console.log({ main_match });
			history.push("/quizexambatches/" + main_match[1]);
		} else if (id_regex.test(exam_link)) {
			console.log({ exam_link });
			history.push("/quizexambatches/" + exam_link);
		} else {
			alert("Invalid Url");
		}
	}
	return (
		<Container>
			Select a course
			<Select
				value={selectedCourse}
				onChange={handleCourseChange}
				options={courses.map((course) => ({
					value: course._id,
					label: course.name,
				}))}
				className="mt-3 z-[75]"
			/>
			<div className="text-center font-semibold text-xl my-3">-OR-</div>
			<div className="flex gap-2">
				<input
					type="text"
					className="border-2 grow py-2 px-1 rounded focus:border-2 focus:border-sky-600 transition-all"
					placeholder="Paste your exam link here"
					ref={linkRef}
				/>
				<button
					className="bg-sky-600 text-white rounded py-2 px-4 hover:bg-sky-700 transition-all"
					onClick={() => handleResultRedirect()}
				>
					Get Result
				</button>
			</div>
			<div className="exams-list-container mt-5">
				{isLoading && <p>Loading...</p>}
				{!isLoading && exams && (
					<TableVirtuoso
						data={exams.data.data}
						components={VirtuosoTableComponents}
						useWindowScroll
						itemContent={rowContent}
						fixedHeaderContent={fixedHeaderContent}
					/>
				)}
			</div>
		</Container>
	);
};

export default Quizexambybatches;
